<template>
  <p
    class="terms-and-conditions mt-3 mb-5"
    :class="{ 'safety-assistant': safetyAssistant }"
  >
    {{ $t('terms.prefix') }}
    <a href="https://salussafety.io/terms-of-service" target="_blank">
      {{ $t('terms.termsLink') }}
    </a>
    {{ $t('terms.middle') }}
    <a href="https://salussafety.io/privacy-policy" target="_blank">
      {{ $t('terms.privacyLink') }}</a
    >.
  </p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TermsAndConditions',
  computed: {
    ...mapGetters({
      safetyAssistant: 'safetyAssistant',
    }),
  },
}
</script>

<style lang="sass">
.terms-and-conditions
  color: $darkGrey
  font-size: 0.75rem
  font-style: italic
  line-height: 1.5
  margin: auto
  max-width: 350px
  text-align: center
  width: 100%
  a
    text-decoration: none

.safety-assistant
  &.terms-and-conditions
    color: $textMuted !important
    a
      color: $primaryBlue !important
      &:hover
        text-decoration: underline
</style>
